import React from "react";
import langData from "../lang/data";
export default function UseGetDate(propsDate, currentLanguage = "hy") {
  let date = propsDate ? new Date(propsDate) : new Date(); 

  return (
    <>
      {`${date.getDate()} ${
        langData?.months?.[date.getMonth() + 1]?.[currentLanguage]
      } ${date.getFullYear()}`}
    </>
  );
}
